export const defaultCheckListItems = [
  {
    id: 'aumentar_taxa',
    label: 'Aumentar taxa',
    refNegocioForm: 'taxa',
  },
  {
    id: 'reduzir_carencia',
    label: 'Reduzir carência',
    refNegocioForm: 'carencia',
  },
  {
    id: 'reduzir_prazo',
    label: 'Reduzir prazo',
    refNegocioForm: 'prazo_financiamento',
  },
  {
    id: 'incluir_tac',
    label: 'Incluir TAC',
    refNegocioForm: 'tacSN',
  },
  {
    id: 'incluir_prestamista',
    label: 'Incluir prestamista',
    refNegocioForm: 'seguroSN',
  },
  {
    id: 'incluir_tab',
    label: 'Incluir TAB',
    refNegocioForm: 'tabSN',
  },
  {
    id: 'solicitar_renda',
    label: 'Solicitar renda',
    refNegocioForm: 'renda',
  },
  {
    id: 'incluir_avalista',
    label: 'Incluir avalista',
    refNegocioForm: 'avalista',
  },
  {
    id: 'solicitar_20_entrada',
    label: 'Solicitar 20% de entrada',
    refNegocioForm: 'valor_entrada',
  },
];
